module.exports = __webpack_public_path__ + "static/media/portal-cta-background.95e6ca4a.webp";